import React from 'react';
import { Box, Typography, Paper, Grid, Divider } from '@mui/material';
import { getTeacherUser } from '../api/teacherApi';

const InfoRow = ({ label, value }) => (
  <Grid item xs={12} sm={6}>
    <Typography variant="caption" color="text.secondary" sx={{ textTransform: 'uppercase', letterSpacing: '0.5px' }}>
      {label}
    </Typography>
    <Typography variant="body1" sx={{ fontWeight: 600 }}>{value || '—'}</Typography>
  </Grid>
);

// NOTE: the sample login response shared so far was for a *student* login,
// where `employee_details` was null. Field names below (designation, mobile,
// etc.) are best guesses for what a teacher's employee_details will contain
// — adjust once you can check a real teacher login response.
const Profile = () => {
  const user = getTeacherUser();
  const employee = user?.employee_details || {};

  return (
    <Box>
      <Typography variant="h5" sx={{ mb: 2 }}>My profile</Typography>

      <Paper elevation={0} sx={{ p: 3, borderRadius: '18px', border: '1px solid', borderColor: 'divider', mb: 3 }}>
        <Grid container spacing={2}>
          <InfoRow label="Name" value={user?.employee_name} />
          <InfoRow label="User ID" value={user?.user_id} />
          <InfoRow label="Designation" value={employee.designation} />
          <InfoRow label="Email" value={employee.email} />
          <InfoRow label="Mobile No." value={employee.mobile_no} />
          <InfoRow label="Branch" value={user?.branch_name} />
          <InfoRow label="Organization" value={user?.organization_name} />
        </Grid>
      </Paper>

      {user?.courses?.length > 0 && (
        <Paper elevation={0} sx={{ p: 3, borderRadius: '18px', border: '1px solid', borderColor: 'divider' }}>
          <Typography variant="subtitle1" sx={{ mb: 2 }}>Assigned courses</Typography>
          <Divider sx={{ mb: 2 }} />
          <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1 }}>
            {user.courses.map((c) => (
              <Typography key={c.course_id} variant="body2" sx={{ py: 0.5 }}>
                {c.course_name} — {c.batch_name}
              </Typography>
            ))}
          </Box>
        </Paper>
      )}
    </Box>
  );
};

export default Profile;
